import { HomeIcon, RefreshCwIcon } from "lucide-react";

export function ErrorFallbackPage({
  error,
  onReset,
  onGoHome,
}: {
  error: Error;
  onReset: () => void;
  onGoHome: () => void;
}) {
  return (
    <div style={{ minHeight: "100svh", display: "grid", placeItems: "center", padding: "2rem 1.25rem" }}>
      <div className="cb-panel cb-rise" style={{ width: "100%", maxWidth: "34rem" }}>
        <div className="cb-panel__head">
          <span className="cb-panel__title" style={{ color: "var(--cb-error)" }}>
            falha na interface
          </span>
        </div>
        <div className="cb-panel__body" style={{ display: "grid", gap: "1.1rem" }}>
          <p style={{ margin: 0, color: "var(--cb-text)" }}>
            {error.message || "Ocorreu uma falha inesperada ao renderizar o painel."}
          </p>

          {error.stack && (
            <details>
              <summary className="cb-label" style={{ cursor: "pointer" }}>
                stack trace
              </summary>
              <pre
                className="cb-workout-text"
                style={{
                  marginTop: "0.6rem",
                  maxHeight: "14rem",
                  overflow: "auto",
                  padding: "0.75rem",
                  borderRadius: "0.5rem",
                  background: "var(--cb-surface2)",
                  border: "1px solid var(--cb-border)",
                  fontSize: "0.7rem",
                }}
              >
                {error.stack}
              </pre>
            </details>
          )}

          <div className="cb-row" style={{ gap: "0.6rem" }}>
            <button type="button" className="cb-btn cb-btn--primary" onClick={onReset}>
              <RefreshCwIcon size={14} />
              Tentar novamente
            </button>
            <button type="button" className="cb-btn cb-btn--ghost" onClick={onGoHome}>
              <HomeIcon size={14} />
              Início
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
